/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '../../../component/UserProvider/UserProvider';
import { getFromlocalstorage } from '../../../component/MaHoaDuLieu';
import Loading from '../../../component/Loading/Loading';
import Notify from '../../../component/Notify/Notify';
import CheckCrypto from '../../../component/CheckCrypto/CheckCrypto';
import './CaiDatRutTien.scss';

const CaiDatRutTien = () => {
  const navigate = useNavigate();
  const [amounts, setAmounts] = useState({ qr: '', usdt: '' });
  const [receivedAmount, setReceivedAmount] = useState(0);
  const [password, setPassword] = useState('');
  const [method, setMethod] = useState('qr');
  const [loading, setLoading] = useState(false);
  const [message, setNotification] = useState('');
  const { user, fetchUser } = useUser();
  const hasFetched = useRef(false);

  const data = JSON.parse(getFromlocalstorage('data_u'));
  const depositAmounts = [50, 100, 200, 500, 1000, 5000, 10000, 20000];
  const apiUrl = process.env.REACT_APP_API_BACKEND;
const [type, setType] = useState("error");
  useEffect(() => {
    if (data && !hasFetched.current) {
      fetchUser(data._id);
      hasFetched.current = true;
    }
  }, [data]);

  const totalBalance =
    Number((user?.coins || 0).toFixed(0)).toLocaleString('en-US') || 0;

  const handleAmountClick = (value) => {
    setAmounts((prev) => ({
      ...prev,
      [method]: value,
    }));
    setReceivedAmount(value * 1);
  };

  const handleInputChange = (e) => {
    const value = Number(e.target.value);
    setAmounts((prev) => ({
      ...prev,
      [method]: value,
    }));
    setReceivedAmount(value * 1);
  };

  const handleChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '');
    setPassword(numericValue);
  };

  const handleWithdraw = async () => {
    const currentAmount = amounts[method];
    if (currentAmount < 100) {
      setNotification('จำนวนเงินขั้นต่ำคือ 100 THB', 'error');
      return;
    }

    if (!password) {
      setNotification('กรุณากรอกรหัสผ่านการถอนเงิน', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/ruttien/${data._id}`, {
        amount: amounts[method],
        type: method === 'qr' ? 'withdraw' : 'withdraw-crypto',
        mkruttien: password,
      });

      if (response.status === 200) {
        setNotification('ถอนเงินสำเร็จ');
        setType('success');
        setAmounts((prev) => ({
          ...prev,
          [method]: '',
        }));
        setReceivedAmount(0);
        setPassword('');
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    } catch (error) {
      let errorMessage = 'เกิดข้อผิดพลาดในการถอนเงิน';
      if (error.response) {
        errorMessage = error.response.data.error || 'ถอนเงินไม่สำเร็จ';
        setNotification(
          errorMessage === 'รหัสผ่านไม่ถูกต้อง'
            ? 'รหัสผ่านไม่ถูกต้อง'
            : 'ยอดเงินคงเหลือไม่เพียงพอ'
        );
      } else {
        setNotification('ยอดเงินคงเหลือไม่เพียงพอ');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loading isLoading={loading} />
      <div className="deposit-container">
       <div className='deposit-header'>
        
          <Link to="/usermobile">
            <div className="deposit-left">
              <img src="./caidat/back.png" alt="Back" />
            </div>
          </Link>
          <div className="deposit-title">ถอนเงิน</div>
          <div className="deposit-right"></div>
   
       </div>

        <div>
          <div className="deposit-method">
          <div
            className={`deposit-method-item ${method === 'qr' ? 'active' : ''}`}
            onClick={() => setMethod('qr')}
          >
            <img src="./quet_ma_qr.png" alt="ธนาคาร" />
            <div className="deposit-method-name">ถอนเงินผ่านบัญชีธนาคาร</div>
          </div>
          <div
            className={`deposit-method-item ${method === 'usdt' ? 'active' : ''}`}
            onClick={() => CheckCrypto(navigate, setMethod)}
          >
            <img src="./icon_usdt.png" alt="USDT" />
            <div className="deposit-method-name">ถอนเงินด้วย USDT</div>
          </div>
        </div>

        {method && (
          <>
            <div className="deposit-input">
              <div className="input-wrapper">
                <input
                  type="number"
                  placeholder="กรอกจำนวนเงิน"
                  value={amounts[method] || ''}
                  onChange={handleInputChange}
                  className="amount-input"
                  autoComplete="off"
                />
               
              </div>
              <div className="rut-info">
                <span className="title-rut">จำนวนเงินสูงสุดที่สามารถถอนได้</span>
                {/* <img
                  src="/icon_usdt.png"
                  alt="USDT"
                  className="usdt-icon"
                /> */}
                <span>{totalBalance} THB</span>
              </div>
              <div className="deposit-choice">
                <div className="deposit-result">
                  = {receivedAmount.toLocaleString('en-US')} THB
                </div>
                <div className="deposit-units-label">หน่วย</div>
                <div className="deposit-buttons">
                  {depositAmounts.map((value) => (
                    <button
                      key={value}
                      onClick={() => handleAmountClick(value)}
                      className="amount-button"
                    >
                      {value}
                    </button>
                  ))}
                </div>
              </div>
              <div className="deposit-warning-text">
                   ทุกธุรกรรมมีค่าธรรมเนียม กรุณาตรวจสอบให้ละเอียด
              </div>
              <div className="input-wrapper">
                <input
                  type="password"
                  name="password_withdrawal"
                  value={password}
                  onChange={handleChange}
                  placeholder="กรอกรหัสผ่านการถอนเงิน"
                  className="password-input"
                  autoComplete="new-password"
                  required
                />
              </div>
            </div>
            <div className="deposit-proceed">
              <button
                type="button"
                className="btn-proceed"
                onClick={handleWithdraw}
                disabled={loading}
              >
                  ถอนเงิน
              </button>
            </div>
          </>
        )}
        </div>
      </div>
      {message && <Notify message={message} type={type} setcontent={setNotification} />}
    </>
  );
};

export default CaiDatRutTien;